import { Box, Card, Flex, Space, Text } from '@/components';
import type { PaymentNodeData } from '@/features/mold/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Handle, type NodeProps, Position } from 'reactflow';

export const PaymentGraphNode: FC<NodeProps<PaymentNodeData>> = ({
  id,
  data,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Handle
        id={id}
        type="target"
        position={Position.Top}
        style={{ zIndex: 1 }}
      />
      <Box position="relative">
        <Card
          styles={{
            header: {
              margin: 0,
              minHeight: 'unset',
              padding: '5px 24px',
              background: '#16828b',
              color: '#fff',
              border: '1px solid #16828b',
              fontSize: 16,
              fontWeight: 500,
              textTransform: 'capitalize',
              maxWidth: 220,
            },
            body: {
              padding: '5px 24px',
              border: '1px solid #16828b',
              maxWidth: 220,
            },
          }}
          className="ant-card-data"
          title={
            <Flex gap={4}>
              {data.displayCode && (
                <Text text={`${data.displayCode}.`} color="white" />
              )}
              <Text
                text={data.title}
                color="white"
                style={{ whiteSpace: 'normal' }}
              />
            </Flex>
          }
        >
          <Space direction="vertical">
            <Text style={{ fontSize: 12 }} text={data.label} />
            {typeof data.paymentCount === 'number' && (
              <Text
                style={{ fontSize: 12 }}
                text={`${t('payment-count')}: ${data.paymentCount.toString()}`}
              />
            )}
            {data.overview && (
              <Text
                style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}
                text={data.overview}
              />
            )}
          </Space>
        </Card>
        <Box
          position="absolute"
          top={0}
          right={0}
          transform="translateX(calc(100% + 8px))"
        >
          {data.paymentIndirectCostTextList && (
            <Flex vertical>
              {data.paymentIndirectCostTextList.map(
                (paymentIndirectCostText, index) => {
                  return (
                    <Text
                      // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
                      key={index}
                      text={paymentIndirectCostText}
                      weight="regular"
                    />
                  );
                },
              )}
            </Flex>
          )}
        </Box>
      </Box>
      <Handle id={id} type="source" position={Position.Bottom} />
    </>
  );
};
